import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import React from "react";
import TeamSectionHeader from "../Text/TeamSectionHeader";
import classes from './MeetTheCeo.module.scss'

type Props = React.ComponentPropsWithoutRef<"div">;

const MeetTheCEO = ({ ...htmlProps }: Props) => {
  const { t } = useTranslation("team");
  return (
    <div {...htmlProps} className={classes.meetTheCeo__container}>
      <TeamSectionHeader
        title={t("meetTheCEO.title")}
        text={t("meetTheCEO.text")}
        className="p-0"
      />
      <div className={classes.meetTheCeo__photoBox}>
        <Image
          alt="ceo"
          src="/images/team/honza.webp"
          width={204}
          height={136}
          sizes="100vw"
          className={classes.meetTheCeo__ceoImg}
        />
      </div>
    </div>
  );
};

export default MeetTheCEO;
